import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const MagicLinkLogin = () => {
  return (
    <>
      <h5>
        <b>Magic Link Login</b>
      </h5>
      <p>
        Magic links are one-time links that are sent to users to login to your web app during the
        authentication process. Once, users signup to your web app, they are sent a link or URL via
        email to help them login to the web app.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/magic-link" />
    </>
  );
};

export default MagicLinkLogin;
